export type LocalizedTextByLocale = Record<string, string>;
export type LocalizedText = string | LocalizedTextByLocale;

function toLanguageCode(localeCode?: string | null): string | null {
  if (localeCode == null || localeCode.trim() === '') return null;
  return localeCode.substring(0, 2).toLowerCase();
}

export function getLocalizedText(
  value: LocalizedText | null | undefined,
  localeCode?: string | null
): string {
  if (value == null) return '';
  if (typeof value === 'string') return value;

  const languageCode = toLanguageCode(localeCode);
  if (languageCode != null && value[languageCode] != null) {
    return value[languageCode];
  }

  if (value.en != null) {
    return value.en;
  }

  return Object.values(value).find((text) => text != null && text.trim() !== '') ?? '';
}

export function localizedTextEquals(
  value: LocalizedText | null | undefined,
  expected: string,
  localeCode?: string | null
): boolean {
  return getLocalizedText(value, localeCode) === expected;
}
